import React from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import { Controller } from "stimulus";

export default class extends Controller {

  initialize() {
    if (!this.data.get("initialized")) {
      this.initReactSelect();
    }
  }

  connect() {
    this.refreshHandler = () => this.renderReactSelect();
    this.element.addEventListener("react-select:refresh", this.refreshHandler);
  }

  disconnect() {
    if (this.refreshHandler) {
      this.element.removeEventListener("react-select:refresh", this.refreshHandler);
    }
  }

  initReactSelect() {
    this.select = this.element.querySelector("select");
    this.select.style.display = "none";

    this.renderReactSelect();

    this.data.set("initialized", true);
  }

  // react-select usa defaultValue (uncontrolled) — só é lido no mount. Por
  // isso, quando o <select> nativo muda por fora (ex: filtro de config em
  // cascata em alert_rule_form_controller escondendo/desmarcando opções),
  // um "react-select:refresh" no elemento força um remount completo num
  // container novo, em vez de só chamar ReactDOM.render de novo (que não
  // atualizaria a seleção exibida).
  renderReactSelect() {
    const select = this.select;

    const options = [...select.options].filter(opt => !opt.hidden);
    const defaultValue = [...select.selectedOptions].filter(opt => !opt.hidden);

    const placeholder = select.getAttribute('placeholder');

    const isMulti = select.getAttribute("multiple") != null;

    const isClearable = true;

    const onChange = value => {
      if (!Array.isArray(value)) {
        // Just set the value if this is a single select
        select.value = value ? value.value : '';
      } else {
        // Update native select option by option (use .selected property, not attribute)
        const selected = value.map(opt => opt.value);
        for (const opt of select.options) {
          opt.selected = selected.includes(opt.value);
        }
      }

      select.dispatchEvent(new Event("change"));
    };

    if (this.reactSelectContainer) {
      ReactDOM.unmountComponentAtNode(this.reactSelectContainer);
      this.reactSelectContainer.remove();
    }

    this.reactSelectContainer = document.createElement("div");
    select.parentNode.insertBefore(this.reactSelectContainer, select);

    ReactDOM.render(
      <Select
        className={'my-react-select-container'}
        classNamePrefix={'my-react-select'}
        options={options}
        defaultValue={defaultValue}
        onChange={onChange}
        isMulti={isMulti}
        isClearable={isClearable}
        placeholder={placeholder}
      />,
      this.reactSelectContainer
    );
  }

}
